import { createLoadingType, createSetType } from '../actionHelpers';

export const APP_LOADING = createLoadingType('APP_LOADING');
export const ADD_LOADER = createLoadingType("ADD_LOADER");
export const REMOVE_LOADER = createLoadingType("REMOVE_LOADER");
export const ABOUT_ROUTE_SELECTED = createSetType("ABOUT_ROUTE_SELECTED");
export const IS_ONLINE_SET = createSetType("IS_ONLINE_SET");
export const OPEN_ONLINE_POPOVER = createSetType("OPEN_ONLINE_POPOVER");
